import { render, staticRenderFns } from "./BlogDetails.vue?vue&type=template&id=1bbc2865"
import script from "./BlogDetails.vue?vue&type=script&lang=js"
export * from "./BlogDetails.vue?vue&type=script&lang=js"
import style0 from "./BlogDetails.vue?vue&type=style&index=0&id=1bbc2865&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports